export default __webpack_public_path__ + "static/media/JamesTomassoniResume.3933eb13.pdf";